import { IReferenceMediaItem, ReferenceMediaImageType } from 'types/aiVideo'
import FilledFrame from './FilledFrame'
import EmptyFrame from './EmptyFrame'
import { IMyFilesMediaItem } from 'types/media'
import { useCallback } from 'react'

interface IFrameProps {
  type: ReferenceMediaImageType
  label: string
  sublabel?: string
  frameData?: IReferenceMediaItem
  onMediaLibFileSelect: (
    type: ReferenceMediaImageType,
    files: IMyFilesMediaItem[]
  ) => void
  onUpload: (
    type: ReferenceMediaImageType
  ) => (files: File[] | FileList) => Promise<void>
  onRemove: (id: string) => void
  disabled?: boolean
  testId?: string
}

const Frame: React.FC<IFrameProps> = ({
  type,
  label,
  sublabel,
  frameData,
  onMediaLibFileSelect,
  onUpload,
  onRemove,
  disabled,
  testId
}) => {
  const handleMediaLibFileSelect = useCallback(
    (files: IMyFilesMediaItem[]) => {
      onMediaLibFileSelect(type, files)
    },
    [onMediaLibFileSelect, type]
  )

  const handleUpload = useCallback(
    (files: File[] | FileList) => {
      return onUpload(type)(files)
    },
    [onUpload, type]
  )

  if (frameData) {
    return <FilledFrame frameData={frameData} onRemove={onRemove} />
  }

  return (
    <EmptyFrame
      testId={testId}
      label={label}
      subLabel={sublabel}
      onMediaLibFileSelect={handleMediaLibFileSelect}
      onUpload={handleUpload}
      disabled={disabled}
    />
  )
}

export default Frame
